import s from '../allservices.jsx'

const getValidUseridService = (actionCallback,validUserId )=> {

    fetch(s.valid_user_id + "/" + validUserId , {
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    })
        .then(res => {
       
            if (res.status === 200 || res.status === 201 || res.status === 204 || res.status === 304) {
                res.json().then(json => actionCallback(json, "success"))
            } else {
                res.json().then(json => actionCallback(json, "error"))
            }
        })
}

export default getValidUseridService;


// WEBPACK FOOTER //
// ./src/services/components/valid_userid.jsx